import { QueryFieldFilterConstraint, where } from "firebase/firestore";
import { SubscriptionFilters } from "../domain/use_cases/subscriptions/getSubscriptionsWithFilters";

export const getSubscriptionFilters = async (filters: SubscriptionFilters): Promise<QueryFieldFilterConstraint[]> => {
    const subscriptionConstraints = [];

    if (filters?.employeesInCharge && filters.employeesInCharge.length > 0) {
        subscriptionConstraints.push(
            where('employee_incharge_uid', 'in', filters.employeesInCharge)
        );
    }

    if (filters?.status === 'expired') {
        subscriptionConstraints.push(
            where('plan_end', '<', new Date().getTime())
        );
    } else if (filters?.status === 'active') {
        subscriptionConstraints.push(
            where('plan_end', '>', new Date().getTime())
        )
    }

    if (filters?.plans && filters.plans.length > 0) {
        subscriptionConstraints.push(
            where('id_plan', 'in', filters.plans)
        );
    }

    if (filters?.subStatus) {
        subscriptionConstraints.push(
            where('status', '==', filters.subStatus)
        )
    }

    if (filters?.crmUsed && filters?.crmUsed.length > 0) {
        subscriptionConstraints.push(
          where('datasource', 'in', filters.crmUsed)
        )
      }

    return subscriptionConstraints;
};